import React, { Component } from "react";

class TimelineItem extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		const {
			className,
			item,
			activeColor,
			inactiveColor,
			activeIcon,
			inactiveIcon,
			borderActive,
			lengthMax,
			lastItem
		} = this.props;

		// Border style
		const componentColor = lengthMax ? "default" : !!item && borderActive ? activeColor : "default";

		// Dot style
		const dotColor =
		lastItem && lengthMax ? inactiveColor : lengthMax ? activeColor : !!item && item.active ? activeColor : !!item && item.active === false ? inactiveColor : "default";

		const style = [
			"timeline-item-component",
			!!item && item.active && "timeline-item-component--active",
			className,
			componentColor
		].join(" ");

		return (
			<div className={style}>
				{!!item && (
					<div className="timeline-item-component__content">
						<div
							className="timeline-item-component__content--title"
							dangerouslySetInnerHTML={{ __html: item.label }}
						/>
						<div className="timeline-item-component__content--center">
							<div
								className={`timeline-item-component__content--dot ${dotColor}`}
							>
								<i
									className={`icon-${
										lastItem && lengthMax ? inactiveIcon : lengthMax || item.active ? activeIcon : item.active === false && inactiveIcon
									}`}
								/>
							</div>
						</div>
						<div
							className="timeline-item-component__content--description"
							dangerouslySetInnerHTML={{ __html: item.description }}
						/>
					</div>
				)}
			</div>
		);
	}
}

TimelineItem.defaultProps = {
	activeColor: "success",
	inactiveColor: "danger"
};

export default TimelineItem;
